import Vue from 'vue'
import Confirm from '../components/UIElements/Utils/NativeComponents/Confirm'
import Alert from '../components/UIElements/Utils/NativeComponents/Alert'
import Notificacion from '../components/UIElements/Utils/NativeComponents/Notification'
import api from "../api/config";

Vue.prototype.$useCaptcha = false;
Vue.prototype.$flagTyCPila = false;
Vue.prototype.$flagTyCDEL = false;

api.get().then((response) => {
    if (response.keyCaptcha){
        // Vue.use(VueReCaptcha, {
        //     siteKey: response.keyCaptcha,
        //     loaderOptions: {
        //         useRecaptchaNet: true,
        //         autoHideBadge: true
        //     }
        // });    
        Vue.prototype.$keyCaptcha = response.keyCaptcha;
        Vue.prototype.$useCaptcha = response.useCaptcha;
        Vue.prototype.$flagTyCPila = response.flagTyCPila;
        Vue.prototype.$flagTyCDEL = response.flagTyCDEL
        Vue.prototype.$idProductoPILA = response.idProductoPILA
        Vue.prototype.$idProductoDEL = response.idProductoDEL
        
    }
})

Vue.use(Confirm, {
    buttonTrueText: 'Aceptar',
    buttonFalseText: 'Cancelar',
    color: 'green',
    icon: '',
    title: '',
    width: '30em'
})

Vue.use(Alert, {
    buttonTrueText: 'Aceptar',
    buttonTrueColor: '',
    buttonFalseText: null,
    color: 'red',
    icon: '',
    title: 'Error',
    width: '25em',
    center: true
})

Vue.use(Notificacion, {
    buttonTrueText: 'Aceptar',
    buttonFalseText: null,
    color: 'green',
    icon: '',
    title: '',
    width: '30em',
    center: true
})
